<template>
    <div class="file-list" v-if="currentComponent">
        <el-card>
            <component
                :is="currentComponent"
                ref="warehouseListComponent"
                :filters="filters"
            />
        </el-card>
    </div>
</template>

<script>
export default {
    name: 'fileList',
    props: {
        filters: {
            type: Object,
            required: false,
            default: () => null
        }
    },
    data() {
        return {
            components: {
                PY: () =>
                    import(
                        '@/modules/warehouse/views/pages/viewBatchRecord/components/file-list/py.vue'
                    )
            }
        };
    },
    mounted() {
    },
    computed: {
        currentComponent() {
            this.$emit('input', []);
            const user = this.$store.state.usuarioLogado;
            return this.components[user.paisGrupo];
        }
    },
    watch: {
    },
    methods: {
    }
};
</script>

<style scoped lang="scss">
</style>
